import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './PartnersSection.css';
import istokLogo from '../images/partners/istok-audio-logo.png';
import vertikalLogo from '../images/partners/vertikal-logo.png';
import spbInstituteLogo from '../images/partners/spb-institute-logo.png';

const PartnersSection = () => {
    // Данные о партнерах
    const partners = [
        {
            id: 1,
            name: 'Исток Аудио Трейдинг',
            logo: istokLogo,
            description: 'Лидирующее предприятие реабилитационной индустрии по слуху в России. Предлагает широкий ассортимент слуховых аппаратов и средств адаптации для слабослышащих. Официальный дистрибьютор ведущих мировых производителей – Исток Аудио Интернэшнл, Oticon, ReSound, Phonak, Bernafon, Siemens, Otometrics, Interacoustics и других.',
            url: 'https://www.istok-audio.com/'
        },
        // {
        //     id: 2,
        //     name: 'ООО «Вертикаль»',
        //     logo: vertikalLogo,
        //     description: 'Ведущий производитель тактильных мнемосхем и печатной продукции по системе Брайля. Разрабатывает комплексные решения для программы "Доступная Среда". Специализируется на помощи слабовидящим и незрячим.',
        //     url: 'https://tiflocentre.ru/'
        // },
        // {
        //     id: 3,
        //     name: 'ЗАО «Санкт-Петербургский институт профилактической медицины»',
        //     logo: spbInstituteLogo,
        //     description: 'Головная организация по внедрению методики галотерапии в России с 1989 года. Разрабатывает и внедряет инновационные методы профилактической медицины.',
        //     url: 'https://galokamera.com/'
        // }
    ];

    return (
        <section className="partners-section">
            <Container>
                {/* Заголовок секции */}
                <Row className="mb-4 mt-3">
                    <Col className="text-center">
                        <h2 className="section-title">Партнеры</h2>
                    </Col>
                </Row>
                
                {/* Карточки партнеров */}
                {partners.map(partner => (
                    <Row key={partner.id} className="partner-item mb-3 align-items-center">
                        {/* Логотип партнера */}
                        <Col lg={3} md={4} sm={12} className="text-center mb-md-0 mb-4">
                            <a href={partner.url} target="_blank" rel="noopener noreferrer">
                                <div className="partner-logo-wrapper">
                                    <Image 
                                        src={partner.logo} 
                                        alt={partner.name} 
                                        className="partner-logo img-fluid" 
                                    />
                                </div>
                            </a>
                        </Col>
                        
                        {/* Информация о партнере */}
                        <Col lg={9} md={8} sm={12}>
                            <h3 className="mb-3">
                                <a href={partner.url} target="_blank" rel="noopener noreferrer" className="partner-name">
                                    {partner.name}
                                </a>
                            </h3>
                            <p className="partner-description text-secondary">
                                {partner.description}
                            </p>
                        </Col>
                    </Row>
                ))}
            </Container>
        </section>
    );
};

export default PartnersSection;